@if (questions().length > 0) {
  <div class="carousel m-2 w-full">
    @for (question of questions(); track question.name) {
      <div
        class="carousel-item w-full"
        [class.hidden]="currentIndex() != $index"
      >
        <app-quizz-question
          [question]="question"
          (questionAnswered)="questionAnswered($event)"
        ></app-quizz-question>
      </div>
    }
    <div
      class="carousel-item"
      [class.hidden]="currentIndex() != questions().length"
    >
      <button class="btn btn-primary" (click)="checkAnswers()">
        {{ "instruction-details.chapter-quizz.check-answers" | translate }}
      </button>
    </div>
  </div>
} @else {
  <!-- confirm directly! -->
  <button class="btn btn-primary" (click)="checkAnswers()">
    {{ "common.confirm" | translate }}
  </button>
}
